import type { ContentData, ResolvedContent } from '@episerver/content-delivery'
import { normalizeContentUrl } from './normalizeContentUrl'

export default () => {
  // useState, not a module-level reactive: module state is shared across requests on the
  // Workers isolate, so a concurrent NOTFOUND could overwrite a real page's content. P180PCM-296.
  const pending = useState<boolean>('content:pending', () => false)
  const resolvedContent = useState<ResolvedContent<ContentData>>(
    'content:resolved',
    () => ({} as ResolvedContent<ContentData>),
  )

  const updateContentByUrl = async (url: string): Promise<{ failed: boolean }> => {
    if (!url || typeof url !== 'string' || url.includes('undefined')) {
      return { failed: false }
    }
    pending.value = true
    const normalizedUrl = normalizeContentUrl(url)

    if (isUnresolvableProductDetailsPath(normalizedUrl)) {
      resolvedContent.value = {} as ResolvedContent<ContentData>
      pending.value = false
      return { failed: false }
    }

    const apiUrl = isProductPage(normalizedUrl) ? '/api/products/content/' : '/api/content/'
    try {
      const { data, error } = await useFetch(`${apiUrl}?contentUrl=${normalizedUrl}`)
      if (error.value) {
        throw error.value
      }
      resolvedContent.value = (data.value ?? {}) as ResolvedContent<ContentData>
      return { failed: false }
    }
    catch (e) {
      if (((e as any)?.statusCode ?? (e as any)?.response?.status) === 404) {
        resolvedContent.value = {} as ResolvedContent<ContentData>
        return { failed: false }
      }
      console.error('[content] failed to resolve content; backend may be unavailable', e)
      return { failed: true }
    }
    finally {
      pending.value = false
    }
  }

  return {
    pending: readonly(pending),
    resolvedContent: readonly(resolvedContent),
    updateContentByUrl,
  }
}
